import { render, staticRenderFns } from "./ModalHandedImageDetail.vue?vue&type=template&id=3ec8ac6c&scoped=true"
import script from "./ModalHandedImageDetail.vue?vue&type=script&lang=js"
export * from "./ModalHandedImageDetail.vue?vue&type=script&lang=js"
import style0 from "./ModalHandedImageDetail.vue?vue&type=style&index=0&id=3ec8ac6c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ec8ac6c",
  null
  
)

export default component.exports